
<div class="progress-bar"
     [ngClass]="{'progress-bar--contrast': contrast}"
>
  <div class="progress-bar__progress" [style]="{'width': progress + '%'}"></div>
</div>
